export enum TableCellTypes {
    Number = 'number',
    Button = 'button',
    Rate = 'rate',
    Date = 'date',
    Dropdown = 'dropdown'
}
